export enum VerificationStep {
  InputNumber,
  Sent,
  Verified,
};
